import { Controller } from "@hotwired/stimulus"

// Handles click-outside-to-close behavior for <details> dropdowns
export default class extends Controller {
  closeOnClickOutside(event) {
    // If click is outside this element, close it
    if (!this.element.contains(event.target)) {
      this.element.removeAttribute('open')
    }
  }
}
